import { useState } from 'react';

const RENDERER_LOADER_WAIT_MS = 10;

export const useRenderLoader = (): [boolean, (updateFn: () => void) => void] => {
  const [loading, setLoading] = useState<boolean>(false);
  return [
    loading,
    updateFn => {
      setLoading(true);
      setTimeout(() => {
        updateFn();
        setLoading(false);
      }, RENDERER_LOADER_WAIT_MS);
    },
  ];
};
